import React from "react";
import { connect } from "react-redux";
import { partial, applySpec } from "ramda";

import {
  selectThumbnailFile,
  hideEditThumbnailDialog,
  saveThumbnailFile,
} from "edit-media/redux/editMediaActions";

import {
  getEditMediaItem,
  getEditThumbnailDialogVisible,
  getThumbnailDialogFile,
  getThumbnailDialogProcessing,
} from "common/selectors";

import FileUploadInput from "components/FileUploadInput";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/ArrowBack";
import SaveIcon from "@material-ui/icons/Save";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import { green, grey } from "@material-ui/core/colors";
import Typography from "@material-ui/core/Typography";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative",
    backgroundColor: grey[200],
  },

  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },

  saveButton: {
    backgroundColor: green[500],
    color: theme.palette.primary.contrastText,
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  dialogBody: {
    padding: 24,
  },

  container: {
    position: "relative",
    padding: "2rem",
    fontSize: "1.25rem !important",
    overflowY: "scroll",
  },

  subContainerHeader: {
    fontSize: "1.75rem",
    fontWeight: "bold",
  },

  subContainerRoles: {
    padding: "1.5rem",
  },

  field: {
    marginBottom: "0.5rem",
  },

  text: {
    fontSize: "1.6rem !important",
  },

  fileUpload: {
    marginBottom: 40,
  },
}));

const EditThumbnailDialog = ({
  onApply,
  onCancel,
  onChange,
  visible,
  media,
  thumbnailFile,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      fullScreen
      open={visible}
      TransitionComponent={Transition}
      onClose={onCancel}
    >
      <AppBar className={classes.appBar}>
        <Toolbar classes={{ root: classes.toolbar }}>
          <Button color="default" startIcon={<CloseIcon />} onClick={onCancel}>
            Cancel
          </Button>
          <Typography color="primary" variant="h6" className={classes.title}>
            Edit Thumbnail
          </Typography>
          <Button
            variant="contained"
            classes={{ root: classes.saveButton }}
            onClick={partial(onApply, [media.id, thumbnailFile])}
            startIcon={<SaveIcon />}
          >
            {"Save"}
          </Button>
        </Toolbar>
      </AppBar>
      <Paper square elevation={0} classes={{ root: classes.dialogBody }}>
        <div className={classes.container}>
          <div>
            <div className={classes.subContainerHeader}>
              Select a Thumbnail Image
            </div>

            <div className={classes.subContainerRoles}>
              <FileUploadInput
                className={classes.fileUpload}
                value={thumbnailFile}
                accept=".jpg, .jpeg, .png, .gif, image/jpeg, image/png, image/gif"
                onChange={onChange}
                // error={firstError(errors, "workFile")}
              />
            </div>
          </div>
        </div>
      </Paper>
    </Dialog>
  );
};

const mapStateToProps = applySpec({
  media: getEditMediaItem,
  visible: getEditThumbnailDialogVisible,
  thumbnailFile: getThumbnailDialogFile,
  thumbnailProcessing: getThumbnailDialogProcessing,
});

const mapDispatchToProps = dispatch => ({
  onApply: (mediaId, file) => dispatch(saveThumbnailFile(mediaId, file)),
  onCancel: () => dispatch(hideEditThumbnailDialog()),
  onChange: file => dispatch(selectThumbnailFile(file)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditThumbnailDialog);
